import {put, takeLatest, call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    DELETE_PRODUCT_TYPE,
    DELETE_PRODUCT_TYPE_SUCCESS,
    DELETE_PRODUCT_TYPE_ERROR
}
    from "../../../actions/menu/productTypes";

function* deleteProductTypeSaga(action) {
    try {
        yield call(productTypeService.DeleteProductType, action.payload)
        yield put({
            type: DELETE_PRODUCT_TYPE_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_PRODUCT_TYPE_ERROR,error: error.data
        });
    }
}


export function* deleteProductTypeSagaWatcher() {
    yield takeLatest(DELETE_PRODUCT_TYPE, deleteProductTypeSaga);
}